import SearchCardImageShimmer from './search-card-image/shimmer'
import s from './style.module.css'
import clsx from 'clsx'

const SearchResultCardShimmer = () => {
  return (
    <div className={s.result_container}>
      <div className={s.game_img_and_text}>
        <SearchCardImageShimmer />
        <div className={s.text_container}>
          <p className={clsx(s.name_shimmer, s.shimmer)} />
          <p className={clsx(s.play_count_shimmer, s.shimmer)} />
        </div>
      </div>
    </div>
  )
}

export default SearchResultCardShimmer
